
<template>
  <zm-modal
    ref="modal"
    @ok="handleSubmit"
    :title="title"
    :visible="visible"
    size="middle"
    @cancel="open(false)"
  >
    <div slot="modalBody" class="modal_body">
      <a-form :form="form">
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="姓名">
              <a-input
                disabled
                autocomplete="off"
                v-model="model.userName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所属部门">
              <a-input
                disabled
                autocomplete="off"
                v-model="model.deptName"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="职位">
              <a-input
                disabled
                autocomplete="off"
                v-model="model.departmentJobStr"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="入职日期">
              <a-input
                disabled
                autocomplete="off"
                :value="formatTime(model.entryDate)"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="转正日期">
              <a-date-picker
                style="width: 100%"
                placeholder="请选择转正日期"
                v-decorator="['formallyDate', { rules: [{ required: false, message: '请选择转正日期！' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </zm-modal>
</template>

<script>
import { cancelApplication } from '@/api/applicant'
import moment from 'moment'
import { changeJobStatus } from '@/api/baseInfo'
export default {
  name: 'cancelApplication',
  components: {},
  data () {
    return {
      title: '操作',
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'cancelApplication' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 2 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      colSpan: 24
    }
  },
  methods: {
    formatTime (time, type) {
      return time ? moment(time).format(type || 'YYYY-MM-DD') : ''
    },
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if (flag) {
        
      } else {
        this.model = {}
      }
    },
    // 提交表单
    handleSubmit () {
      this.form.validateFieldsAndScroll(async (err, value) => {
        if (!err) {
          const params = { ...value }
          params.id = this.model.id
          params.formallyDate = this.formatTime(value.formallyDate)
          this.$refs.modal.handleOkLoading(true)
          const res = await changeJobStatus(params).catch((error) => {
            this.$refs.modal.handleOkLoading(false)
            console.log('操作失败', error)
            this.$message.error('操作失败，请稍后重试！')
          })
          this.$refs.modal.handleOkLoading(false)
          if (res && res.status === 0) {
            this.$message.success(res.info.message)
            this.$emit('refreshTable')
            this.open(false)
          } else {
            this.$message.warning(res.info.message)
          }
        }
      })
    },
    // 清空表单
    formClear () {
      this.$nextTick(() => {
        this.form.resetFields()
      })
    },
    cancel () {
      this.formClear()
      this.open(false)
    }
  }
}
</script>

<style lang="less">
.cancel_application{
  .info{
    margin-bottom: 18px;
    .anticon{
      font-size: 14px;
      color: #ffc66a;
      margin-right: 9px;
    }
  }
}
</style>

